module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img27.a6bf6a66.jpg";